import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.647 3c0-.488.395-.883.882-.883 10.137 0 18.354 8.217 18.354 18.354a.882.882 0 1 1-1.765 0c0-9.162-7.427-16.589-16.589-16.589A.882.882 0 0 1 2.647 3Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.647 10.412c0-.488.395-.883.882-.883 6.043 0 10.942 4.9 10.942 10.942a.882.882 0 0 1-1.765 0 9.177 9.177 0 0 0-9.177-9.177.882.882 0 0 1-.882-.882Z"
      clipRule="evenodd"
    />
    <circle cx={5} cy={19} r={2} fill="#F7A600" />
  </svg>
);
export default SvgTwoColorNetwork;
